import styled from '@emotion/styled';
import LinearProgress from '@mui/material/LinearProgress';
import { mq } from 'src/themes';

const LoadingScreenContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 45rem;
`;

const StyledLoaderContainer = styled.div`
  width: 100%;
  padding: 0 6rem;

  ${mq.sm} {
    padding: 0 4rem;
  }
  ${mq.xs} {
    padding: 0 2rem;
  }
`;

export const LoadingScreen = () => {
  return (
    <LoadingScreenContainer>
      <StyledLoaderContainer>
        <LinearProgress />
      </StyledLoaderContainer>
    </LoadingScreenContainer>
  );
};
